module.exports = __webpack_public_path__ + "img/check.40631fc6.png";